import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import LatestStory from "./components/LatestStory";
import FeaturedCast from "./components/FeaturedCast";
import FeaturedClips from "./components/FeaturedClips";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <SiteLayout>
      <h1 className="sr-only">年轻的母亲-影视剧剧情介绍与精彩片段专题站</h1>
      <HeroCarousel />
      <div className="mt-10 md:mt-14">
        <CategoryEntries />
      </div>
      <LatestStory />
      <FeaturedCast />
      <FeaturedClips />
      <SiteIntro />
    </SiteLayout>
  );
}